export default "__VITE_ASSET__CwhvzNnG__"